import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("admin@payroll.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div
        className="hidden md:block bg-slate-900 relative overflow-hidden"
        style={{
          backgroundImage:
            'url(https://images.unsplash.com/photo-1600068485133-e0ef65324a22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwb2ZmaWNlJTIwaW50ZXJpb3IlMjBjYWxtfGVufDB8fHx8MTc4MjA3OTU1NHww&ixlib=rb-4.1.0&q=85)',
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-slate-950/60" />
        <div className="relative h-full flex flex-col justify-between p-10 text-white">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-md bg-white text-slate-900 grid place-items-center font-mono font-bold">P</div>
            <span className="font-heading text-xl font-semibold">Payroll</span>
          </div>
          <div>
            <h1 className="font-heading text-4xl md:text-5xl font-bold leading-tight tracking-tight">
              Attendance, salary,<br /> and payroll — <span className="text-emerald-300">one calm tool</span>.
            </h1>
            <p className="mt-4 text-slate-300 max-w-md">
              Track daily attendance, compute PF/ESI, and export a monthly salary sheet that mirrors your existing Excel workflow.
            </p>
          </div>
          <div className="text-xs text-slate-400 font-mono">v1.0 · single branch · admin only</div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="login-form">
          <div>
            <h2 className="font-heading text-3xl font-bold text-slate-900">Sign in</h2>
            <p className="text-sm text-slate-500 mt-1">Use your admin credentials to continue.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                   data-testid="login-email" required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                   data-testid="login-password" required />
          </div>
          {error && <div className="text-sm text-rose-600" data-testid="login-error">{error}</div>}
          <Button type="submit" className="w-full h-10" data-testid="login-submit" disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <p className="text-xs text-slate-400 text-center">Default: admin@payroll.com / admin123</p>
        </form>
      </div>
    </div>
  );
}
